import { connect } from 'react-redux'
import Sidebar from './Sidebar'

export default connect(
  (state) => ({
    menu: state.menu,
    user: state.user
  }),
  null,
  null,
  { pure: false }
)(Sidebar)
